import type { RouteLocationNormalized } from 'vue-router';

export type RouteLoadingSkeletonKey = 'product-detail';

type RouteLoadingSkeletonMatcher = {
	key: RouteLoadingSkeletonKey;
	match: (route: RouteLocationNormalized) => boolean;
};

type RouteLoadingSkeletonState = {
	active: boolean;
	key: RouteLoadingSkeletonKey | null;
	startedAt: number;
};

const matchers: RouteLoadingSkeletonMatcher[] = [
	{
		key: 'product-detail',
		match: route => /^\/\d+\/products\/[^/]+(?:\.html)?$/i.test(route.path),
	},
];

export function resolveRouteLoadingSkeleton(route: RouteLocationNormalized): RouteLoadingSkeletonKey | null {
	const matched = matchers.find(item => item.match(route));
	return matched?.key ?? null;
}

export function useRouteLoadingSkeletonState() {
	return useState<RouteLoadingSkeletonState>('route-loading-skeleton', () => ({
		active: false,
		key: null,
		startedAt: 0,
	}));
}

export function showRouteLoadingSkeleton(key: RouteLoadingSkeletonKey) {
	const state = useRouteLoadingSkeletonState();
	state.value = {
		active: true,
		key,
		startedAt: Date.now(),
	};
}

export function hideRouteLoadingSkeleton() {
	const state = useRouteLoadingSkeletonState();
	state.value = {
		active: false,
		key: null,
		startedAt: 0,
	};
}
